"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIssuesWithUniversalMatches = void 0;
const getIssuesWithUniversalMatches = (issues, universalIssues) => {
    const universalIssueIds = universalIssues.reduce((acc, { issueId }) => {
        if (issueId !== null && issueId !== undefined) {
            acc[issueId] = issueId;
        }
        return acc;
    }, {});
    return issues.filter(issue => !!universalIssueIds[issue.id]);
};
exports.getIssuesWithUniversalMatches = getIssuesWithUniversalMatches;
//# sourceMappingURL=getIssuesWithUniversalMatches.js.map